// The betting arithmetic, pure (no Firebase) so tools/net-check.mjs can prove it.
// See bets.js for the rules in words.

/**
 * The split. Pure: same pool + same winner → same numbers on every screen.
 * Returns { [uid]: payout } for EVERY bettor (refunds included).
 * Floors each share and hands the leftover dust out one at a time to the
 * biggest winning stakes first (THE DUST LAW: never burned).
 */
export function settle(bets, winner, { lockAt = Infinity, void: isVoid = false, keys = null } = {}) {
  const list = Object.entries(bets || {})
    .map(([uid, b]) => ({ uid, side: b.side, amount: Math.floor(b.amount || 0), at: typeof b.at === "number" ? b.at : 0, keys: b.keys || null }))
    .filter((b) => b.amount > 0 && (b.side === 0 || b.side === 1));
  const out = {};
  // refunded, never lost: a bet that slipped in after the start, or one made on a
  // pairing that changed before the bell (a player joined the Hourly and took a place)
  const stale = (b) => b.at > lockAt || (keys && b.keys && b.keys.join("|") !== keys.join("|"));
  for (const b of list) if (stale(b)) out[b.uid] = b.amount;
  list.splice(0, list.length, ...list.filter((b) => !stale(b)));
  const W = list.filter((b) => b.side === winner), L = list.filter((b) => b.side !== winner);
  const sw = W.reduce((a, b) => a + b.amount, 0), sl = L.reduce((a, b) => a + b.amount, 0);
  if (isVoid || winner == null || sw === 0) { for (const b of list) out[b.uid] = b.amount; return out; }
  for (const b of L) out[b.uid] = 0;
  let paid = 0;
  for (const b of W) { const share = Math.floor((b.amount * sl) / sw); out[b.uid] = b.amount + share; paid += share; }
  let left = sl - paid;
  const order = W.slice().sort((x, y) => y.amount - x.amount || x.at - y.at || (x.uid < y.uid ? -1 : 1));
  for (let i = 0; left > 0; i = (i + 1) % order.length, left--) out[order[i].uid] += 1;
  return out;
}

/** Totals for the betting panel. */
export function poolTotals(bets) {
  const t = [0, 0], n = [0, 0];
  for (const b of Object.values(bets || {})) if (b && (b.side === 0 || b.side === 1)) { t[b.side] += b.amount || 0; n[b.side]++; }
  return { total: t, count: n };
}

